export interface Styles {
    'color': "black" | "blue" | "red" | "green" | "white" | "gray" | "lightblue" | "lightyellow" | "initial"
    'background-color': "white" | "black" | "ghostwhite" | "peachpuff" | "khaki" | "gray" | "lightgray" | "initial"
    'line-height': "1" | "1.5" | "2" | "3.5" | "initial"
    'word-spacing': "10px" | "normal" | "-2px" | "initial"
    'font-size': "1em" | "10%" | "25%" | "50%" | "75%" | "100%" | "125%" | "150%" | "200%" | "400%" | "initial"
    'font-family': "'Roboto'" | "serif" | "sans-serif" | "monospace" | "initial" | string,
    'text-align': "left" | "right" | "center" | "justify" | "initial" | "inherit",
    'animation': string
}

export enum Tags {
    "p",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "div",
    "body"
}
